//place here your custom javascript, you're free to create all the js files you need

// accordion footer
document.addEventListener('DOMContentLoaded', function () {
    var accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(function (item) {
        var btn = item.querySelector('.accordion-button');

        btn.addEventListener('click', function () {
            item.classList.toggle('active');

            var content = item.querySelector('.accordion-content');
            content.style.display = item.classList.contains('active') ? 'block' : 'none';

            accordionItems.forEach(function (otherItem) {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.accordion-content').style.display = 'none';
                }
            });
        });
    });
});
